export const appsEngagementReportsEngagementReportData =
  "/apps/engagement_reports/engagement_report_data(/:app_group_id)";
